export enum InputType {
  Textbox = 1,
  Checkbox = 2,
  Button = 3,
  TextArea = 4,
  SignatureBlock = 5,
  SignatureDate = 6,
}
